import { CHANGE_INPUT, RESET_CONSENT } from './constants';

export function changeInput({ field, form, value }) {
  return {
    payload: { field, form, value },
    type: CHANGE_INPUT,
  };
}

export function resetConsent() {
  return { type: RESET_CONSENT };
}
